<template>
  <div class="row">
    <div class="flex xs12">
      <va-card title="频道列表">
        <div class="row align--center mb-1">
          <div class="flex md6 xs12">
            <va-button flat disabled color="danger">总计{{totalCount}}条结果</va-button>
          </div>
          <div class="flex xs12 sm6">
            <div class="d-flex justify--end">
              <va-button
                color="info"
                small
                :to= "{name: 'saveChannel' , params: { groupId: this.groupId } }"
              >
                新建频道
              </va-button>
            </div>
          </div>
        </div>
        <va-data-table
          :fields="fields"
          :data="channels"
          :loading="loading"
          @page-selected="listChannel"
          api-mode
          :total-pages="totalPage"
        >
          <template slot="sort" slot-scope="props">
            <va-input
              v-model="props.rowData.sortNum"
              type="number"
              :min="1"
            >
              <va-button slot="append" icon="ion-md-checkmark ion" color="info" small @click="updateSortNum(props.rowData)"></va-button>
            </va-input>
          </template>

          <template slot="type" slot-scope="props">
            <va-badge :color= computeType(props.rowData.type).color>
              {{ computeType(props.rowData.type).text }}
            </va-badge>
          </template>

          <template slot="memberCount" slot-scope="props">
            <va-button
              :to="{ name: 'listChannelMember' , params: { channelId: props.rowData.channelId }}"
              color="dark"
              flat
              small
              outline
            >
              {{props.rowData.memberCount}}
            </va-button>
          </template>

          <template slot="actions" slot-scope="props">
            <va-popover message="编辑" placement="top">
              <va-button flat small color="gray" icon="fa fa-pencil"
                :to= "{name: 'updateChannel' , params: { groupId: props.rowData.groupId , id: props.rowData.id } }"
              />
            </va-popover>
            <va-popover message="删除" placement="top">
              <va-button
                flat
                small
                color="gray"
                icon="fa fa-trash"
                @click="deleteModal = true; deleteId=props.rowData.id"/>
            </va-popover>
            <va-popover message="群组聊天" placement="top">
              <va-button
                flat
                small
                color="gray"
                icon="fa fa-comments-o"
                :to = "{name:'chat',params:{channelId: props.rowData.channelId}}"
              />
            </va-popover>
          </template>
        </va-data-table>
        <va-modal
          v-model="deleteModal"
          title="删除群组"
          okText="提交"
          position="center"
          message="请再次确认是否要删除？"
          @ok="confirmDelete"
        />
      </va-card>
    </div>
  </div>
</template>

<script>

import groupApi from '../../api/group'

export default {
  data () {
    return {
      message: ['Required field'],
      channels: [],
      loading: true,
      groupId: null,
      deleteModal: false,
      deleteId: null,
      totalCount: 0,
      totalPage: null,
    }
  },
  computed: {
    fields () {
      return [
        {
          name: '__slot:sort',
          title: '排序',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '10%',
        },
        {
          name: 'name',
          title: '频道名',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '20%',
        },
        {
          name: '__slot:type',
          title: '群组类型',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '20%',
        },
        {
          name: '__slot:memberCount',
          title: '群成员',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '20%',
        },
        {
          name: '__slot:actions',
          width: '30%',
          title: '操作',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
      ]
    },
  },
  created () {
    const params = this.$route.params
    this.groupId = params.groupId
    this.listChannel()
  },
  methods: {
    listChannel (pageNumber = 1) {
      this.loading = true
      const data = {
        pageSize: 20,
        pageNumber: pageNumber,
        groupId: this.groupId
      }
      groupApi.listChannel(this.groupId, data)
        .then(response => {
          this.channels = response.channels
          this.totalCount = response.totalCount
          this.totalPage = response.totalPage
          this.loading = false
        })
    },
    confirmDelete () {
      console.log(this.deleteId)
      if (this.deleteId == null) return
      groupApi.deleteChannel(this.deleteId)
        .then(response => {
          if (response.success === true) {
            this.listChannel()
          }
        })
    },
    computeType: function (type) {
      const data = {
        color: 'gray',
        text: '普通',
      }
      if (type === 2) {
        data.color = 'success'
        data.text = '付费'
      }
      return data
    },
    updateSortNum: function (params) {
      if (params.sortNum === null) {
        return
      }
      const data = {
        sortNum: params.sortNum,
      }
      groupApi.updateChannelSortNum(params.id, data).then(response => {
        if (response.success === true) {
          this.showToast('更新排序成功', {
            duration: 1000,
            icon: 'fa-success',
            position: 'top-center',
            fullWidth: false,
          })
          this.listChannel()
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
  },
}

</script>

<style lang="scss">
.data-table-server-pagination---avatar {
  width: 60px;
  height: 60px;
  border-radius: 5%;
}
</style>
